import { useHistory, useLocation } from 'react-router-dom'
import { Nav } from 'react-bootstrap'
import { app } from '../../../../config'
import { navigateTo } from '../../navigation'
import {
  ROUTE_LOGOUT,
  ROUTE_PROFILE,
  ROUTE_SUBSCRIPTION,
  ROUTE_SUPPORT,
  ROUTE_SUPPORT_RESOURCES,
  KEY_RESOURCE_ID,
  ROUTE_NOTIFICATIONS,
  ROUTE_HISTORY,
  ROUTE_CHAT_GENERAL
} from '../../helpers/Paths'
import ComplianceFooter from '../../navigation/ComplianceFooter'
import { isiOS, isAndroid } from 'components/common/helpers/Mobile'

const _resourceUrl = url =>
  ROUTE_SUPPORT_RESOURCES.replace(`:${KEY_RESOURCE_ID}`, url)

/**
 * Simple Account Menu component. Used to display the user account or user profile menu
 */
export default function AccountMenu({ setNavbarExpanded }) {
  const history = useHistory()
  const { pathname } = useLocation()

  const resourcesUrl = _resourceUrl(app.resources.pages.resources)
  // const userGuideUrl = _resourceUrl(app.resources.pages.user_guide)

  // Menu links
  const links = [
    { path: ROUTE_PROFILE, title: 'Profile' },
    // Don't show notifications option if we're not on a device that supports them
    (isiOS('1.0.17') || isAndroid()) && {
      path: ROUTE_NOTIFICATIONS,
      title: 'Reminders'
    },
    { path: ROUTE_SUBSCRIPTION, title: 'Subscription' },
    { path: ROUTE_HISTORY, title: 'History' },
    { path: resourcesUrl, title: 'Resources' },
    { path: ROUTE_CHAT_GENERAL, title: 'Mia User Guide' }
    // { path: userGuideUrl, title: 'Remble User Guide' } // Disabled for now
  ]

  const handleClick = (event, targetPath) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (setNavbarExpanded) setNavbarExpanded(false)
    return navigateTo(targetPath, history)
  }

  return (
    <>
      <Nav className='justify-content-end flex-grow-1'>
        {links.map(
          link =>
            link && (
              <Nav.Link
                className={`${pathname === link.path ? 'active' : ''}`}
                to={'#'}
                onClick={e => handleClick(e, link.path)}
                key={link.path}
              >
                {link.title}
              </Nav.Link>
            )
        )}

        <Nav.Link href={ROUTE_LOGOUT}>Logout</Nav.Link>
      </Nav>
      <div className='help' onClick={_ => handleClick(_, ROUTE_SUPPORT)}>
        <i className='icon bi-send'></i>
        <span className='help-text'>How can we help?</span>
      </div>
      <ComplianceFooter setNavbarExpanded={setNavbarExpanded} />
    </>
  )
}
